import { createTheme } from '@mui/material/styles';

/**
 * Create and return a custom Material UI theme. Controls primary and secondary colors
 */
export function getTheme() {
  const customTheme = createTheme({
    palette: {
      primary: {
        main: '#003d73', // Delphinus blue
      },
      secondary: {
        main: '#37a0cb', // Delphinus cyan
      },
    },
  });

  return customTheme;
}
